import { RootState } from '../index';
import { Participant, StoreStatus } from '../../core/types/common.types';

export const errorSelector = (state: RootState): any | null => state.participants.errors || null;

export const isBusySelector = (state: RootState): boolean => state.participants.status === StoreStatus.BUSY;

export const responseSelector = (state: RootState): Participant[] | any => state.participants.response || [];

export const hasSuccessSelector = (state: RootState): boolean => (state.participants.response ? true : false);
